import { createFeatureSelector, createSelector } from '@ngrx/store';
import { selectUser } from 'common/store/genesys-cloud/users/selectors/user.selectors';
import { selectActiveMessageConversationCount, selectAllMessageConversationIds, selectMessageConversationById } from 'common/store/genesys-cloud/conversations/messages/selectors/message-conversation.selectors';
import { selectActiveEmailConversationCount, selectAllEmailConversationIds, selectEmailConversationById } from 'common/store/genesys-cloud/conversations/emails/selectors/email-conversation.selectors';
import { conversationsTopicName, conversationsTypingTopicName } from '../helpers/conversation-topics';
import { memoize } from 'lodash';
import { ConversationBase } from '../models/conversation-base.model';
import { GenesysCloudCommonConversationsState } from '../genesys-cloud-common-conversations.state';
import { featureKey } from '../reducers/feature-key';

export const selectState = createFeatureSelector<GenesysCloudCommonConversationsState>(featureKey);

export const selectConversationsNotificationTopicName = createSelector(selectUser, user => conversationsTopicName(user?.id));
export const selectConversationsTypingNotificationTopicName = createSelector(selectUser, user => conversationsTypingTopicName(user?.id));

export const selectAllConversationIds = createSelector(
  selectAllMessageConversationIds,
  selectAllEmailConversationIds,
  (messageConversationIds, emailConversationIds) => [
    ...messageConversationIds,
    ...emailConversationIds
  ]);

export const selectAllActiveConversationCount = createSelector(
  selectActiveMessageConversationCount,
  selectActiveEmailConversationCount,
  (messageConversationCount, emailConversationCount) => messageConversationCount + emailConversationCount
);
export const selectConversationById = memoize((conversationId: string) => createSelector(
  selectMessageConversationById(conversationId),
  selectEmailConversationById(conversationId),
  (messageConversation, emailConversation): ConversationBase => messageConversation ?? emailConversation
));
